import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-approval-modal',
  templateUrl: './approval-modal.component.html',
  styleUrls: ['./approval-modal.component.scss']
})
export class ApprovalModalComponent {

  @Input() changedAccordion: string;
  justification: string;

  constructor(public activeModal: NgbActiveModal) { }

  closeModal() {
    this.activeModal.dismiss();
  }
}
